import HeatLegend from './HeatLegend';
export default HeatLegend;
